import { Button } from '@mantine/core'
import { useRouter } from '@tanstack/react-router'

export function CancelButton() {
  const { history } = useRouter()
  return (
    <Button variant="light" onClick={() => history.go(-1)} tabIndex={0}>
      Cancel
    </Button>
  )
}
